import { ortto_communication_api } from '@axo/shared/data-access/api';
import { useAPI } from '@axo/shared/data-access/provider';
import { useMutation, useQueryClient } from 'react-query';
import { orttoTransactionalCommunicationKeys } from '../cache-keys/orttoTransactionalCommunicationKeys';

/** Mutes a customer's transactional communication in one market (MV-3396). */
export function useStopTransactionalCommunication() {
  const api = useAPI();
  const client = useQueryClient();

  return useMutation(
    (params: { customerID: string; country: string }) =>
      ortto_communication_api.stopTransactionalCommunication(api)(params),
    {
      onSuccess: (_, { customerID }) =>
        client.invalidateQueries(
          orttoTransactionalCommunicationKeys.customer(customerID)
        ),
    }
  );
}
